import React, {useEffect, useS} from "react";

import { useLocation } from "@reach/router"

import 'bootstrap/scss/bootstrap.scss'
import "../scss/global.scss";
import "../scss/grunticon.scss"
import "../scss/custom.scss";
import "slick-carousel/slick/slick.css";
import "../scss/myaccount.scss"

import $ from 'jquery'

import Header from "./Header/Header";
import Footer from "./Footer/Footer"
import SEO from "../common/seo";


const Layout = (props) => {

  var { hash } = useLocation()

  const [state, setState] = React.useState({
    showMenu: false
  })

  const handlerClick = () => {
    setState({ ...state, showMenu: !state.showMenu })
  }

  useEffect(() => {

    //$(`${hash}`).css("scroll-marigin-top", "100px")
    //console.log("pathname", hash)

    if(hash){
      setTimeout(() => {
        $('html, body').scrollTop($(hash).offset().top - 250);
      }, 200)
    }

  }, [])

  useEffect(() => {
    //console.log("showMenu", state.showMenu)
    if (state.showMenu) {
      $("body").addClass("overflow_hidden")
    } else {
      $("body").removeClass("overflow_hidden")
    }

  }, [state.showMenu])


  // React.useEffect(() => {
  //   $(window).scrollTop(0);
  //   console.log("scroll_top")
  // }, [props])


  

  return (
    <>
      
      {!props?.dynamicSEO &&
        <SEO title={props?.seo_meta?.title} description={props?.seo_meta?.description} image={props?.seo_meta?.image?.url} />
      }
      <div className={`main_container ${props?.menu_slug ? props.menu_slug.replace(/-/g, '_')+"_cls" : ""} ${props?.GQLPage?.layout} ${props?.GQLPage?.page_class}`}>
        <div className={state.showMenu ? "open-search-block" : "header_cnt"}>
          <Header showMenu={state.showMenu} handlerClick={handlerClick} stickyHeader={props.stickyHeader}  GQLPage={props.GQLPage}/>
        </div> 

          {props.children}
        <Footer isJourneySec={props.isJourneySec} menu_slug={props.menu_slug} searchParams={props.searchParams} popular_search={props.popular_search} footerCls={props.footerCls} GQLPage={props.GQLPage} /> 
      </div>
    </>

  )
}


export default Layout;
